import { render, staticRenderFns } from "./MarksHistory.vue?vue&type=template&id=49c93c3c&scoped=true"
import script from "./MarksHistory.vue?vue&type=script&lang=js"
export * from "./MarksHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c93c3c",
  null
  
)

export default component.exports